<template>
    <div>
        <h3>Top 5 defects this week</h3>
        <table class="table">
            <thead>
            <th width="90%"></th>
            <th widht="10%"></th>
            </thead>
            <tbody>
            <tr v-for="(defect,index) in topList">
                <td>{{index+1}}. {{defect.name}}</td>
                <td> {{defect.percentage ? defect.percentage.toFixed(2) : 0}}%</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>


<script>

    export default {
        name: 'counter',
        components: {},
        props: ['defects'],


        data() {
            return {}
        },
        computed: {
            topList() {
                if (this.defects) {
                    return this.defects.slice(0, 5)
                }
            }
        },
        created() {

        }
    }
</script>
<style lang="scss" scoped>

    td {
        font-size: 20px;
        font-weight: 700;
        color: #3a3e3f;

    }
</style>